import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    Button,
    Label,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import Select from "react-select";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import "./style.scss";


const FollowupLogs = () => {
    const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
    const [staffOptions, setStaffOptions] = useState([]);
    const [followupData, setFollowupData] = useState([]);
    const [followupstatusOptions, setfollowupstatusOptions] = useState([]);
    const [followupInststatusOptions, setfollowupInststatusOptions] = useState([]);
    const [candidateOptions, setCandidateOptions] = useState([]);
    const [instituteOptions, setInstituteOptions] = useState([]);
    const [allcandidateOptions, setAllCandidateOptions] = useState([]);
    const [preferredPlaceOptions, setPreferredPlaceOptions] = useState([]);
    /** pagination followup */
    const [PerPageCount, setPerPageCount] = useState(20);
    const [followSearch, setfollowSearch] = useState({
        category: 1,
        categoryObject: { label: "Candidate", value: 1 }
    });
    const [searchFollowValue, setSearchFollowValue] = useState("");
    const [totalFPages, setTotalFPages] = useState(0);
    const [currentFPage, setCurrentFPage] = useState(1);
    const [indexOfFLastTransfer, setindexOfFLastTransfer] = useState(
        currentFPage * PerPageCount
    );

    const [indexOfFFirstTransfer, setindexOfFFirstTransfer] = useState(
        indexOfFLastTransfer - PerPageCount
    );
      const [subjectOptions, setSubjectOptions] = useState([]);
        const [selectedGender, setSelectedGender] = useState(null);
    const followuppaginate = (event, value) => {
        setCurrentFPage(value);
        const start = (value - 1) * PerPageCount;
        const end = value * PerPageCount;
        // const indexOfFLastTransfer = value * PerPageCount;
        // // const indexOfFFirstTransfer = indexOfFLastTransfer - PerPageCount;
        setindexOfFFirstTransfer(start);
        setindexOfFLastTransfer(end);
        fetch_candidate_followups(
            searchFollowValue,
            followSearch?.candidate_id,
            followSearch?.from_date,
            followSearch?.to_date,
            followSearch?.status,
            followSearch?.staff,
            followSearch?.category,
            followSearch?.preferred_place_to_work,
            followSearch?.employeeType,
            followSearch?.expectedPackage,
            followSearch?.subject,
            followSearch?.gender,
            start,
            end
        );
    };
    const resetFollowupPaginate = () => {
        setCurrentFPage(1);
        const indexOfFLastTransfer = PerPageCount;
        const indexOfFFirstTransfer = 0;
        setindexOfFFirstTransfer(indexOfFFirstTransfer);
        setindexOfFLastTransfer(indexOfFLastTransfer);
    }
    /** end pagination */
    const fetch_candidate_followups = (
        search = "",
        id = "",
        from_date = "",
        to_date = "",
        status = "", staff = "",
        category = 1,
        prefferedPlace = "",
        employeeType = "",
        expectedPackage = "",
        subject = "",
        gender = "",
        start=0,
        end=20
            ) => {
                console.log(`API called with start: ${start}, end: ${end}`);
                employeeType = employeeType.replace(/&/g, "%26");
        axios
            .get(`${API_URL}followup/candidate-followups?candidate_id=${id}&from_date=${from_date}&to_date=${to_date}&search=${search}&start=${start}&end=${end}&status=${status}&staff=${staff}&category=${category}&preferred_place_to_work=${prefferedPlace}&employee_type=${employeeType}&expected_package=${expectedPackage}&subject_id=${subject}&gender=${gender}`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                setTotalFPages(res.data.limit);
                var result = res.data.data;
                var id = start;
                if (Array.isArray(result)) {
                    var id = start;
                    result.map((item, index) => {
                        id++;
                        item.id = id;
                        item.time1 = moment(item?.followup_time, "hh:mm s").format("hh:mm A")
                        item.nxtdata = item?.followup_next_date ? moment(item?.followup_next_date).format("DD-MM-YYYY") : "";
                        if (Array.isArray(item.preferred_place_to_work)) {
                            item.preferred_place_to_work = item.preferred_place_to_work.join(", ");
                        }
    
                        item.candidate = (
                            <a href={`/${item.category == 1 ? 'candidate' : 'institute'}/${item?.candidate_no}`} target="_blank">{item?.candidate}</a>
                        )
                        item.candidate_no = (
                            <a href={`/${item.category == 1 ? 'candidate' : 'institute'}/${item?.candidate_no}`} style={{ color: "black" }} target="_blank">{item?.candidate_no}</a>
                        )
                    });
                    setFollowupData(result);
                } else {
                    console.error("err");
                }
            });
    }
    const fetch_candidate = () => {
        axios
            .get(`${API_URL}candidate/options?for=followup`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                let list = [];
                let all_list = res.data.data;
                setAllCandidateOptions(all_list);
                const firstLimited = all_list.slice(0, 20);
                firstLimited &&
                    firstLimited.map((el) => {
                        list.push({
                            label: el?.cand_name + " " + el?.cand_reg_no,
                            value: el?._id,
                            reg_no: el?.cand_reg_no
                        });
                    });
                setCandidateOptions(list);
            });
    };
    const fetch_institute = () => {
        axios
            .get(`${API_URL}institute/options`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                let institute_data =
                    res.data.data &&
                    res.data.data.map((el) => {
                        return {
                            label: el?.inst_reg_no + "-" + el?.inst_name,
                            value: el?._id,
                        };
                    });
                setInstituteOptions(institute_data);
            });
    };

    const fetch_followup_status = () => {
        axios
            .get(`${API_URL}followup/followup-status`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                let data =
                    res.data.data &&
                    res.data.data.map((el) => {
                        return {
                            label: el?.name,
                            value: el?._id,
                        };
                    });
                setfollowupstatusOptions([
                    {
                        options: data,
                    },
                ]);
            });
    }
    const fetch_inst_followup_status = () => {
        axios
            .get(`${API_URL}followup/followup-status?type=2`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                let data =
                    res.data.data &&
                    res.data.data.map((el) => {
                        return {
                            label: el?.name,
                            value: el?._id,
                        };
                    });
                setfollowupInststatusOptions([
                    {
                        options: data,
                    },
                ]);
            });
    }
    const fetch_all_staff = () => {
        axios
            .get(`${API_URL}user`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                var staff_data =
                    res.data.data &&
                    res.data.data.map((el) => {
                        if (el?.lastName) el.name = el.firstName + " " + el.lastName;
                        else el.name = el.firstName;
                        return {
                            label: el.name,
                            value: el._id,
                        };
                    });
                setStaffOptions([
                    {
                        options: staff_data,
                    },
                ]);
            });
    };
    const handleFollowFilter = (selected, type) => {
        resetFollowupPaginate();
        switch (type) {
            case "status":
                setfollowSearch({ ...followSearch, "status": selected.value, "stsObject": selected, "statusObject": null })
                break;
        
            case "from_date":
                setfollowSearch({ ...followSearch, "from_date": selected.target.value });
                break;
        
            case "to_date":
                setfollowSearch({ ...followSearch, "to_date": selected.target.value });
                break;
        
            case "staff":
                setfollowSearch({ ...followSearch, "staff": selected.value, "staffObject": selected });
                break;
        
            case "candidate":
                followSearch.category === 1 ? setfollowSearch({ ...followSearch, "candidate_id": selected.value, "candidateObject": selected, "instObject": null }) :
                setfollowSearch({ ...followSearch, "candidate_id": selected.value, "instObject": selected, "candidateObject": null });
                break;
        
            case "category":
                setfollowSearch({ ...followSearch, "category": selected.value, "categoryObject": selected });
                break;
        
            case "preferredPlace":
                const preferredPlaces = selected.map((option) => option.value);
                setfollowSearch({ ...followSearch, preferredPlace: preferredPlaces, preferredPlaceObject: selected });;
                break;
        
            case "employeeType":
                setfollowSearch({ ...followSearch, employeeType: selected.value, employeeTypeObject: selected });
                break;
        
            case "expectedPackage":
                setfollowSearch({ ...followSearch, expectedPackage: selected.value, expectedPackageObject: selected });
                break;
        
            case "subject":
                setfollowSearch({ ...followSearch, subject: selected.value, subjectObject: selected });
                break;
        
            case "gender":
                setfollowSearch({ ...followSearch, gender: selected.value, genderObject: selected });
                break;
        
            default:
                break;
        }
        

    }
    useEffect(() => {
        fetch_candidate_followups(
            searchFollowValue,
            followSearch?.candidate_id,
            followSearch?.from_date,
            followSearch?.to_date,
            followSearch?.status,
            followSearch?.staff,
            followSearch?.category,
            followSearch?.preferredPlace,
            followSearch?.employeeType,
            followSearch?.expectedPackage,
            followSearch?.subject,
            followSearch?.gender
        );
    },[followSearch]);


    const resetFollowupFilter = (value) => {
        resetFollowupPaginate();
        fetch_candidate_followups(searchFollowValue);
        setfollowSearch({
            statusObject: null,
            stsObject: null,
            instObject: null,
            staffObject: null,
            candidateObject: null,
            from_date: "",
            to_date: "",
            category: 1,
            categoryObject: { label: "Candidate", value: 1 },
            preferredPlaceObject: "",
            employeeTypeObject: "",
            expectedPackageObject: "",
            subjectObject:"",
            genderObject:""
        });
    }
    const handleSearchFollowup = (value) => {
        setSearchFollowValue(value)
        resetFollowupPaginate();
        fetch_candidate_followups(value, followSearch?.candidate_id, followSearch?.from_date, followSearch?.to_date, followSearch?.status, followSearch?.staff, followSearch?.category);
    }
    const handleSelectSearch = (inputValue) => {
        if (inputValue) {
            const searchQuery = inputValue.toLowerCase();

            // Filter the data array based on cand_name and cand_reg_no
            let filter_list = [];
            const filteredData = allcandidateOptions.filter((item) => {
                const lowerCaseName = item.cand_name.toLowerCase() + " " + item.cand_reg_no.toLowerCase();
                // Check if the input matches the cand_name or cand_reg_no
                if (lowerCaseName.includes(searchQuery))
                    filter_list.push({ label: item.cand_name + " " + item.cand_reg_no, value: item._id })
            });
            setCandidateOptions(filter_list)
        }
        else {
            let filter_list = [];
            const firstLimited = allcandidateOptions.slice(0, 20);
            firstLimited &&
                firstLimited.map((el) => {
                    filter_list.push({
                        label: el?.cand_name + " " + el?.cand_reg_no,
                        value: el?._id,
                        reg_no: el?.cand_reg_no
                    });
                });
            setCandidateOptions(filter_list);
        }

    }
    const followup_data = {
        columns: [
            {
                label: "#",
                field: "id",
                sort: "asc",
                width: 50,
            },
            {
                label: "Date",
                field: "followup_date",
                sort: "asc",
                width: 150,
            },
            {
                label: "Time",
                field: "time1",
                sort: "asc",
                width: 150,
            },
            {
                label: "Candidate/Institute",
                field: "candidate",
                sort: "asc",
                width: 150,
            },
            {
                label: "Candidate ID/Institute ID",
                field: "candidate_no",
                sort: "asc",
                width: 150,
            },
            {
                label: "Status",
                field: "status",
                sort: "asc",
                width: 400,
            },
            {
                label: "Next",
                field: "nxtdata",
                sort: "asc",
                width: 200,
            },
            {
                label: "Remarks",
                field: "followup_message",
                sort: "asc",
                width: 200,
            },
            {
                label: "Staff",
                field: "staff",
                sort: "asc",
                width: 200,
            },
            {
                label: "Preffered Place",
                field: "preferred_place_to_work",
                sort: "asc",
                width: 200,
              },
              {
                label: "Employee Type",
                field: "employee_type",
                sort: "asc",
                width: 200,
              },
              {
                label: "Expected Package",
                field: "expected_package",
                sort: "asc",
                width: 200,
              }
        ],
        rows: followupData,
    };
    useEffect(() => {
        fetch_followup_status();
        fetch_inst_followup_status();
        fetch_all_staff();
        // fetch_candidate_followups();
        fetch_candidate();
        fetch_institute();
        fetch_subject();
    }, []);
    useEffect(() => {
        if (followupData.length == 0 && indexOfFFirstTransfer != 0) {
            resetFollowupPaginate();
            fetch_candidate_followups(searchFollowValue, followSearch?.candidate_id, followSearch?.from_date, followSearch?.to_date, followSearch?.status, followSearch?.staff, followSearch?.category);
        }

    }, [followupData])


    useEffect(() => {
        const fetchPreferredPlaces = async () => {
            try {
                const response = await axios.get(`${API_URL}followup/preferred-place`,);
                const places = response.data.data; 
                setPreferredPlaceOptions(places.map(place => ({
                    label: place.name,
                    value: place.name
                })));
            } catch (error) {
                console.error('Error fetching preferred places:', error);
            }
        };

        fetchPreferredPlaces();
    }, [API_URL]);
    function tToggle() {
        var body = document.body;
        body.classList.toggle("vertical-collpsed");
        body.classList.toggle("sidebar-enable");
      }
    useEffect(()=>{
        tToggle()
    },[])
    const fetch_subject = () => {
        axios
          .get(`${API_URL}subject/options`, {
            headers: {
              "x-access-token": accessToken,
            },
          })
          .then((res) => {
            let sub_data =
              res.data.data &&
              res.data.data.map((el) => {
                return {
                  label: el?.subject_name,
                  value: el?._id,
                };
              });
            setSubjectOptions([
              {
                options: sub_data,
              },
            ]);
          });
      };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Followup Logs" />
                    <Row>
                        <Col md="12">
                            <Card><CardBody>
                                <Row>
                                    <Col md="2">
                                        <div>
                                            <Label htmlFor="validationCustom05">From</Label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                id="from_date"
                                                name="from_date"
                                                value={followSearch?.from_date}
                                                onChange={(e) => {
                                                    handleFollowFilter(e, "from_date");
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="2">
                                        <div >
                                            <Label htmlFor="validationCustom05">To</Label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                id="to_date"
                                                name="to_date"
                                                value={followSearch?.to_date}
                                                onChange={(e) => {
                                                    handleFollowFilter(e, "to_date");
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col md="2">
                                        <div>
                                            <Label>Followup Category</Label>
                                            <Select
                                                name="category"
                                                value={followSearch?.categoryObject}
                                                onChange={(selected) => {
                                                    handleFollowFilter(selected, "category");
                                                }}
                                                options={[
                                                    { label: "Candidate", value: 1 },
                                                    { label: "Institute", value: 2 }
                                                ]}
                                                classNamePrefix=" select2-selection"
                                            />

                                        </div>
                                    </Col>
                                    {followSearch?.category === 1 ? (
                                        <Col md="2">
                                            <div>
                                                <Label>Status</Label>
                                                <Select
                                                    name="follow_status"
                                                    value={followSearch?.statusObject}
                                                    onChange={(selected) => {
                                                        handleFollowFilter(selected, "status");
                                                    }}
                                                    options={followupstatusOptions}
                                                    classNamePrefix=" select2-selection"
                                                />

                                            </div>
                                        </Col>
                                    ) : (
                                        <Col md="2">
                                            <div>
                                                <Label>Status</Label>
                                                <Select
                                                    name="follow_status"
                                                    value={followSearch?.stsObject}
                                                    onChange={(selected) => {
                                                        handleFollowFilter(selected, "status");
                                                    }}
                                                    options={followupInststatusOptions}
                                                    classNamePrefix=" select2-selection"
                                                />
                                            </div>
                                        </Col>
                                    )}
                                    <Col md="2">
                                        <div>
                                            <Label>Staff</Label>
                                            <Select
                                                name="staff_id"
                                                value={followSearch?.staffObject}
                                                onChange={(selected) => {
                                                    handleFollowFilter(selected, "staff");
                                                }}
                                                options={staffOptions}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                    {followSearch?.category === 1 ? (
                                        <Col md="2">
                                            <div className="mb-3">
                                                <Label>Candidate</Label>
                                                <Select
                                                    name="candidate"
                                                    value={followSearch?.candidateObject}
                                                    onChange={(selected) => {
                                                        handleFollowFilter(selected, "candidate");
                                                    }}
                                                    options={candidateOptions}
                                                    classNamePrefix="select2-selection"
                                                    onInputChange={handleSelectSearch}
                                                // menuPosition={"fixed"}
                                                />
                                            </div>
                                        </Col>
                                    ) : (
                                        <Col md="2">
                                            <div className="mb-3">
                                                <Label>Institute</Label>
                                                <Select
                                                    name="candidate"
                                                    value={followSearch?.instObject}
                                                    onChange={(selected) => {
                                                        handleFollowFilter(selected, "candidate");
                                                    }}
                                                    options={instituteOptions}
                                                    classNamePrefix="select2-selection"
                                                // onInputChange={handleSelectSearch}
                                                // menuPosition={"fixed"}
                                                />
                                            </div>
                                        </Col>
                                    )}
                                   <Col md="2">
                                    <div>
                                      <Label>Preferred Place</Label>
                                      <Select
                                        name="preferredPlace"
                                        value={followSearch?.preferredPlaceObject}
                                        onChange={(selected) => handleFollowFilter(selected, "preferredPlace")}
                                        options={preferredPlaceOptions}
                                        classNamePrefix="select2-selection"
                                        isMulti
                                      />
                                    </div>
                                  </Col>
                                  <Col md="2">
                      <div className="mb-2">
                        <Label>Subject</Label>
                        <Select
                          name="subject"
                          value={followSearch?.subjectObject}
                          onChange={(selected) => {
                            handleFollowFilter(selected, "subject");
                          }}
                          options={subjectOptions}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </Col>
                    <Col md="2">
                        <div className="mb-3">
                          <Label>Gender</Label>
                          <Select
                            name="gender"
                            value={followSearch?.genderObject}
                            onChange={(selected) => {
                                handleFollowFilter(selected, "gender");
                            }}
                            options={[
                              {
                                label: "Male",
                                value: 0,
                              },
                              {
                                label: "Female",
                                value: 1,
                              },
                              {
                                label: "Transgender",
                                value: 2,
                              },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                                  <Col md="2">
                                    <div>
                                      <Label>Employee Type</Label>
                                      <Select
                                       name="employeeType"
                                       value={followSearch?.employeeTypeObject}
                                       onChange={(selected) => handleFollowFilter(selected, "employeeType")}
                                       options={[
                                        { label: "single", value: "single" },
                                        { label: "with spouse", value: "with spouse" },
                                        { label: "with spouse & children", value: "with spouse & children" },
                                        { label: "friends", value: "friends" },
                                      ]}
                                       classNamePrefix="select2-selection"
                                      />
                                    </div>
                                  </Col>
                                  <Col md="2">
                                    <div>
                                      <Label>Expected Package</Label>
                                      <Select
                                        name="expectedPackage"
                                        value={followSearch?.expectedPackageObject}
                                        onChange={(selected) => handleFollowFilter(selected, "expectedPackage")}
                                        options={[
                                          { label: "5000-10000", value: "5000-10000" },
                                          { label: "10000-15000", value: "10000-15000" },
                                          { label: "15000-20000", value: "15000-20000" },
                                          { label: "20000-25000", value: "20000-25000" },
                                          { label: "25000-30000", value: "25000-30000" },
                                          { label: "30000-35000", value: "30000-35000" },
                                          { label: "35000-40000", value: "35000-40000" },
                                          { label: "40000-50000", value: "40000-50000" },
                                          { label: "50000-75000", value: "50000-75000" },
                                          { label: "75000-100000", value: "75000-100000" },
                                          { label: "100000-200000", value: "100000-200000" },
                                          { label: "200000-300000", value: "200000-300000" },
                                          { label: "300000-above", value: "300000-above" }
                                        ]}
                                        classNamePrefix="select2-selection"
                                      />
                                    </div>
                                  </Col>
                                    <Col md="1" style={{ marginTop: "2.5%" }}>
                                        <div className="mb-3">

                                            <Button color="danger" type="reset" onClick={resetFollowupFilter}>
                                                {"Reset"}
                                            </Button>
                                        </div>
                                    </Col>

                                </Row>
                                <MDBDataTable
                                    id="followupTableId"
                                    responsive
                                    bordered
                                    data={followup_data}
                                    searching={true}
                                    info={false}
                                    disableRetreatAfterSorting={true}
                                    paging={false}
                                    onSearch={(value) => { handleSearchFollowup(value) }}
                                    entries={PerPageCount}
                                />
                                {totalFPages > 20 && (
                                    <div className="pagination-div">
                                        {/* Display the page details */}
                                        <div className="page-details">
                                            Showing {indexOfFFirstTransfer + 1} to {indexOfFFirstTransfer + followupData.length} of {totalFPages} entries
                                        </div>
                                        <Pagination
                                            color="standard"
                                            shape="rounded"
                                            defaultPage={1}
                                            count={Math.ceil(totalFPages / PerPageCount)}
                                            page={currentFPage}
                                            onChange={followuppaginate}
                                            info={true}
                                            size="large"
                                        />
                                    </div>
                                )}
                            </CardBody>

                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )

}
export default FollowupLogs;